module.exports = __webpack_public_path__ + "static/media/bc.df91741e.png";